import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const SUPPORTED_LANGUAGES = [
  'en',
  'es',
  'de',
  'fr',
  'ja',
  'zh',
] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export interface LanguageOption {
  label: string;
  value: SupportedLanguage;
}

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  fr: 'Français',
  ja: '日本語',
  zh: '中文',
};

export const LANGUAGE_OPTIONS: LanguageOption[] = SUPPORTED_LANGUAGES.map(
  (lng) => ({ label: LANGUAGE_LABELS[lng], value: lng }),
);

const cdnUrl =
  (typeof window !== 'undefined' ? window.__ENV?.NX_I18N_CDN_URL : '') ?? '';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    ns: ['common'],
    defaultNS: 'common',
    backend: {
      loadPath: `${cdnUrl}/locales/{{lng}}/{{ns}}.json`,
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      // `caches: []` matches aegix-aim-react and is load-bearing, not a
      // default. i18next calls cacheUserLanguage() during init — on the LOGIN
      // page, from `navigator`, before the user has chosen anything. The
      // AuthProvider reconciliation effect (libs/auth-identity provider.tsx)
      // then treats that value as a user preference and PATCHes it onto a
      // BaseUser whose `language` is NULL. `language` is nullable with no
      // default and empty means "no preference — use the district default",
      // NOT English, so caching here would silently convert an intentional
      // NULL into a hard 'en' the district cannot get back.
      caches: [],
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
